// extracted by mini-css-extract-plugin
export var askAiIcon = "_r7-9";
export var container = "_r7-0";
export var groupSeparator = "_r7-a";
export var highlight = "_r7-4";
export var resultIcon = "_r7-5";
export var resultItem = "_r7-7";
export var resultSubtitle = "_r7-3";
export var resultTitle = "_r7-2";
export var resultsList = "_r7-1";
export var searchGroup = "_r7-6";
export var selected = "_r7-8";